import type {
  IAuthSignUpRequestDto,
  IAuthSignUpResponseResponse,
} from "./types";
import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createPostApi } from "@api/util/createPostApi";

const postApis = createPostApi<
  IApiResponse<IAuthSignUpResponseResponse>,
  IPathBaseParam,
  IAuthSignUpRequestDto
>("auth.signUpRequest");

export const signUpRequest = {
  ...postApis,
};
